import React from 'react'

const Wells = () => (
<section><a className="anchor" id="wells"></a>
  <h2>Wells</h2>
    <p>As of v1.15 wells have been incorporated into panels.</p>
    <p>Please refer to the <a href="#panels">Panels</a> section of the library.</p>
  <hr/>
</section>
)

export default Wells



// WEBPACK FOOTER //
// ./styleguide/components/sections/Wells.js